import { isEmpty } from 'lodash';
import { put, select, takeEvery } from 'redux-saga/effects';
import { safeSaga } from 'store';
import {
    SET_APPLICATION_DETAIL_POST_DATA,
    UPDATE_APPLICATION_DETAIL_POST_DATA,
    RESET_APPLICATION_FORM_INITIAL_POST_DATA,
    ADD_DELETE_REQUEST,
    UPDATE_APPLICATION_SITE_DETAIL_POST_DATA,
    UNSET_APPLICATION_FORM_POST_DATA_KEY,
    REMOVE_DELETE_REQUEST,
    DELETE_REMOVE_REQUEST,
    UPDATE_REMOVE_REQUEST_DATA,
    REMOVE_SITE_POST_DATA,
    SET_APPLICATION_DETAIL_VALID,
    SET_TEXTFIELD_ON_BLUR,
} from 'store/key';
import { produce } from 'utility/general';

const getInitialState = () => ({
    postData: {},
    deleteRequest: {},
    removeRequest: {},
    applicationFormId: -1,
    textFieldOnBlur: false, /** use for Declaration And Endorsement "auto-filled" */
});

function* removeDeleteRequestPostData(action) {
    const { applicationDetailPostData } = yield select();
    const { type, id, applicationFormId } = action.payload;

    applicationDetailPostData.applicationFormId = applicationFormId;

    const index = applicationDetailPostData?.deleteRequest?.[type]?.findIndex((item) => {
        return item.id === id;
    });

    // console.log(
    //     '161028 applicationDetailPostDataReducer.js applicationDetailPostData?.deleteRequest',
    //     applicationDetailPostData?.deleteRequest,
    //     index,
    // );

    if (index !== -1 && index !== undefined) {
        applicationDetailPostData.deleteRequest[type].splice(index, 1);

        // remove the key if empty array
        if (applicationDetailPostData.deleteRequest?.[type]?.length === 0) {
            delete applicationDetailPostData.deleteRequest[type];
        }

        yield put({
            type: SET_APPLICATION_DETAIL_POST_DATA,
            payload: applicationDetailPostData,
        });
    }
}

function* updateDeleteRequestPostData(action) {
    const { applicationDetailPostData } = yield select();
    const { type, id, siteInfoId, applicationFormId } = action.payload;

    applicationDetailPostData.applicationFormId = applicationFormId;

    const isIdExist = applicationDetailPostData?.deleteRequest?.[type]?.some((item) => {
        return item.id === id;
    });

    if (!isIdExist) {
        if (!applicationDetailPostData.deleteRequest) {
            applicationDetailPostData.deleteRequest = {};
        }

        if (!applicationDetailPostData.deleteRequest?.[type]) {
            applicationDetailPostData.deleteRequest[type] = [];
        }
        let data = { id };
        /** for site info's document upload case */
        if (siteInfoId !== undefined) {
            data.siteInfo = { id: siteInfoId };
        }
        applicationDetailPostData.deleteRequest[type].push(data);
    }

    yield put({
        type: SET_APPLICATION_DETAIL_POST_DATA,
        payload: applicationDetailPostData,
    });
}

function* updateApplicationDetailPostData(action) {
    try {
        const { applicationDetailPostData } = yield select();

        // type application detail type, e.g. applicationForm, uploadDocuments
        // key is the key in specific form
        // data is the data to the key
        const { type, key, data, applicationFormId } = action.payload;
        applicationDetailPostData.applicationFormId = applicationFormId;

        // if data is not null, update the postData in redux
        if (data !== null) {
            if (key) {
                if (!applicationDetailPostData.postData?.[type]) {
                    applicationDetailPostData.postData[type] = {
                        [key]: data,
                    };
                } else {
                    applicationDetailPostData.postData[type][key] = data;
                }
            } else {
                applicationDetailPostData.postData[type] = data;
            }

            // remove delete request if delete request array contains current changing value
            const index = applicationDetailPostData?.removeRequest?.applicationForm?.[applicationFormId]?.findIndex(
                (item) => item === key,
            );

            if (index >= 0) {
                applicationDetailPostData.removeRequest.applicationForm[applicationFormId].splice(index, 1);
            }

            // if (applicationDetailPostData.removeRequest.applicationForm[applicationFormId].length === 0) {
            //     delete applicationDetailPostData.removeRequest.applicationForm[applicationFormId];
            // }
        }

        // remove delete request if key is updating
        Object.entries(applicationDetailPostData.postData).forEach(([key, value]) => {
            if (value?.length === 0) {
                delete applicationDetailPostData.postData[key];
            }
        });

        yield put({
            type: SET_APPLICATION_DETAIL_POST_DATA,
            payload: applicationDetailPostData,
        });
    } catch (error) {
        console.log('152304 applicationDetailPostDataReducer.js error', error);
    }
}

function* updateApplicationSiteDetailPostData(action) {
    const { applicationDetailPostData } = yield select();

    // key is the key in specific form
    // data is the data to the key
    // siteInfoId is the id of site would like to update
    const { key, data, siteInfoId, applicationFormId = -1 } = action.payload;
    applicationDetailPostData.applicationFormId = applicationFormId;

    if (!applicationDetailPostData.postData.siteInfo) {
        applicationDetailPostData.postData.siteInfo = [];
    }

    if (data !== null) {
        const index = applicationDetailPostData.postData.siteInfo.findIndex((item) => {
            return item.id === siteInfoId;
        });

        if (index === -1) {
            applicationDetailPostData.postData.siteInfo.push({
                id: siteInfoId,
                [key]: data,
            });
        } else {
            applicationDetailPostData.postData.siteInfo[index][key] = data;
        }

        // remove delete request if delete request array contains current changing value
        const dataIndex = applicationDetailPostData?.removeRequest?.siteInfo?.[siteInfoId]?.findIndex(
            (item) => item === key,
        );

        if (dataIndex >= 0) {
            applicationDetailPostData.removeRequest.siteInfo[siteInfoId].splice(index, 1);

            if (applicationDetailPostData.removeRequest.siteInfo[siteInfoId].length === 0) {
                delete applicationDetailPostData.removeRequest.siteInfo[siteInfoId];
            }
        }
    }

    yield put({
        type: SET_APPLICATION_DETAIL_POST_DATA,
        payload: applicationDetailPostData,
    });
}

function* removeSitePostData(action) {
    const { applicationDetailPostData, applicationDetailValid } = yield select();
    const { siteInfoId = -1, applicationFormId } = action.payload;

    applicationDetailPostData.applicationFormId = applicationFormId;

    const index = applicationDetailPostData.postData?.siteInfo?.findIndex?.((item) => item.id === siteInfoId);

    if (index !== undefined && index !== -1) {
        applicationDetailPostData.postData.siteInfo.splice(index, 1);
        if (applicationDetailPostData.postData.siteInfo.length === 0) {
            delete applicationDetailPostData.postData.siteInfo;
        }
    }

    const newPostData = {};

    // remove all table create request
    Object.entries(applicationDetailPostData.postData).forEach(([key, value]) => {
        if (key === 'applicationForm') {
            newPostData['applicationForm'] = value;
        } else {
            const newTableData = applicationDetailPostData.postData[key].filter(
                (item) => item?.siteInfo?.id !== siteInfoId,
            );

            newPostData[key] = newTableData;

            if (newPostData[key].length === 0) {
                delete newPostData[key];
            }
        }
    });

    applicationDetailPostData.postData = newPostData;

    // if remove request exist
    if (applicationDetailPostData.removeRequest?.siteInfo?.[siteInfoId]) {
        delete applicationDetailPostData.removeRequest.siteInfo[siteInfoId];
        if (isEmpty(applicationDetailPostData.removeRequest.siteInfo)) {
            delete applicationDetailPostData.removeRequest.siteInfo;
        }
    }

    // if delete request exist (ignore this case, server will handle when site remove)
    const newDeleteRequest = {};
    Object.entries(applicationDetailPostData.deleteRequest).forEach(([key, value]) => {
        const newDeleteData = applicationDetailPostData.deleteRequest[key].filter(
            (item) => item?.siteInfo?.id !== siteInfoId,
        );

        newDeleteRequest[key] = newDeleteData;

        if (newDeleteRequest[key].length === 0) {
            delete newDeleteRequest[key];
        }
    });

    applicationDetailPostData.deleteRequest = newDeleteRequest;

    yield put({
        type: SET_APPLICATION_DETAIL_POST_DATA,
        payload: applicationDetailPostData,
    });

    // remove site validation data
    delete applicationDetailValid.siteInfoValid[siteInfoId];

    yield put({
        type: SET_APPLICATION_DETAIL_VALID,
        payload: applicationDetailValid,
    });
}

function* deleteRemoveRequest(action) {
    const { applicationDetailPostData } = yield select();
    const { siteInfoId = -1, keys = [], applicationFormId = -1 } = action.payload;

    applicationDetailPostData.applicationFormId = applicationFormId;

    keys.forEach((key) => {
        let index = -1;

        // case of application form
        if (siteInfoId === -1) {
            index = applicationDetailPostData?.removeRequest?.applicationForm?.[
                applicationDetailPostData.applicationFormId
            ]?.findIndex((item) => {
                return item === key;
            });
        } else {
            // case of site form
            index = applicationDetailPostData?.removeRequest?.siteInfo?.[siteInfoId]?.findIndex((item) => {
                return item === key;
            });
        }

        if (index >= 0) {
            if (siteInfoId === -1) {
                applicationDetailPostData.removeRequest.applicationForm[
                    applicationDetailPostData.applicationFormId
                ].splice(index, 1);

                if (
                    applicationDetailPostData.removeRequest.applicationForm[applicationDetailPostData.applicationFormId]
                        .length === 0
                ) {
                    delete applicationDetailPostData.removeRequest.applicationForm;
                }
            } else {
                applicationDetailPostData.removeRequest.siteInfo[siteInfoId].splice(index, 1);

                if (applicationDetailPostData.removeRequest.siteInfo[siteInfoId].length === 0) {
                    delete applicationDetailPostData.removeRequest.siteInfo[siteInfoId];
                }
            }
        }
    });

    yield put({
        type: SET_APPLICATION_DETAIL_POST_DATA,
        payload: applicationDetailPostData,
    });
}

function* updateRemoveRequestData(action) {
    const { applicationDetailPostData } = yield select();
    const { applicationFormId, type, data } = action.payload;
    applicationDetailPostData.applicationFormId = applicationFormId;

    if (data !== undefined) {
        applicationDetailPostData.removeRequest[type] = {
            [applicationFormId]: data,
        };
        if (data === null) {
            delete applicationDetailPostData.removeRequest[type];
        }
    }
    yield put({
        type: SET_APPLICATION_DETAIL_POST_DATA,
        payload: applicationDetailPostData,
    });
}

function* setTextFieldOnBlur(action) {
    const { applicationDetailPostData } = yield select();
    const { textFieldOnBlur } = action.payload;

    if (textFieldOnBlur !== undefined) {
        applicationDetailPostData.textFieldOnBlur = textFieldOnBlur;

        yield put({
            type: SET_APPLICATION_DETAIL_POST_DATA,
            payload: applicationDetailPostData
        });
    }
}

const reducer = (state = getInitialState(), action) => {
    switch (action.type) {
        case RESET_APPLICATION_FORM_INITIAL_POST_DATA:
            return getInitialState();
        case SET_APPLICATION_DETAIL_POST_DATA:
            const { applicationFormId } = action.payload;

            if (!applicationFormId || applicationFormId === -1) {
                console.log('093452 applicationDetailPostDataReducer.js action.payload', action.payload);
                throw new Error('application id is required to update reducer');
            }

            // eslint-disable-next-line eqeqeq
            if (state.applicationFormId != applicationFormId) {
                state = getInitialState();
                state.applicationFormId = applicationFormId;
            }

            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        case UNSET_APPLICATION_FORM_POST_DATA_KEY:
            const unsetState = produce(state, (draft) => {
                delete draft.postData[action.payload];
            });
            return unsetState;
        default:
            return state;
    }
};

export function* watchApplicationDetailPostData() {
    yield takeEvery(UPDATE_APPLICATION_DETAIL_POST_DATA, safeSaga(updateApplicationDetailPostData));
    yield takeEvery(UPDATE_APPLICATION_SITE_DETAIL_POST_DATA, safeSaga(updateApplicationSiteDetailPostData));
    yield takeEvery(ADD_DELETE_REQUEST, safeSaga(updateDeleteRequestPostData));
    yield takeEvery(REMOVE_DELETE_REQUEST, safeSaga(removeDeleteRequestPostData));
    yield takeEvery(DELETE_REMOVE_REQUEST, safeSaga(deleteRemoveRequest));
    yield takeEvery(UPDATE_REMOVE_REQUEST_DATA, safeSaga(updateRemoveRequestData));
    yield takeEvery(REMOVE_SITE_POST_DATA, safeSaga(removeSitePostData));
    yield takeEvery(SET_TEXTFIELD_ON_BLUR, safeSaga(setTextFieldOnBlur));
}

export default reducer;
